import { handleActions } from 'redux-actions';
import { actions } from '../actions/attachmentsPreviewModal';
const { attachmentsPreviewModalOpen, attachmentsPreviewModalClose } = actions;
export const initialState = {
    fileName: null,
    url: null,
};
const reducer = handleActions({
    [attachmentsPreviewModalOpen.toString()]: (state, action) => {
        const { fileName, url } = action.payload;
        return Object.assign(Object.assign({}, state), { url,
            fileName });
    },
    [attachmentsPreviewModalClose.toString()]: (state, action) => {
        return initialState;
    },
}, initialState);
export default reducer;
